module.exports = __webpack_public_path__ + "static/media/small-rickshaw.dbc467bc.png";